import { render, staticRenderFns } from "./order-assign-dialog.vue?vue&type=template&id=50e32068&"
import script from "./order-assign-dialog.vue?vue&type=script&lang=js&"
export * from "./order-assign-dialog.vue?vue&type=script&lang=js&"
import style0 from "./order-assign-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports